import Profile from "@/components/pages/profile/Index";
import ProfileDashboard from "@/components/pages/profile/sections/Dashboard";
import ProfileLoginForm from "@/components/pages/profile/sections/Login";
import ProfileAddressForm from "@/components/pages/profile/sections/Address";
import ProfileSubscriptionsForm from "@/components/pages/profile/sections/Subscriptions";
import ProfileUserForm from "@/components/pages/profile/sections/User";
import ProfileServerManagement from "@/components/pages/profile/sections/ServerManagement";

import * as pages from "./../pageNameConstants";

export default {
  path: "/profile",
  component: Profile,
  children: [
    {
      path: "",
      name: pages.PROFILE_HOMEPAGE,
      component: ProfileDashboard
    },
    {
      path: "user",
      name: pages.PROFILE_USER,
      component: ProfileUserForm
    },
    {
      path: "login",
      name: pages.PROFILE_LOGIN,
      component: ProfileLoginForm
    },
    {
      path: "billing",
      name: pages.PROFILE_BILLING,
      component: ProfileAddressForm
    },
    {
      path: "subscriptions",
      name: pages.PROFILE_NEWSLETTERS,
      component: ProfileSubscriptionsForm
    },
    {
      path: "server-management",
      name: pages.PROFILE_SERVER_MANAGEMENT,
      component: ProfileServerManagement
    }
  ]
};
